import { render, staticRenderFns } from "./save_money.vue?vue&type=template&id=0e2ff65a&scoped=true&"
import script from "./save_money.vue?vue&type=script&lang=js&"
export * from "./save_money.vue?vue&type=script&lang=js&"
import style0 from "./save_money.vue?vue&type=style&index=0&id=0e2ff65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ff65a",
  null
  
)

export default component.exports